import ThurstanCollege from '../assets/images/thurstancollegelogo.png'
import Univeristylogo from '../assets/images/Kelaniyauniversity.png'
import DepartmentLogo from '../assets/images/MITlogol.png'
import iterminalTechonologies from '../assets/images/iterminal.png'
import VizuaMatix from '../assets/images/vizua_matix.png'
import ParcelInternational from '../assets/images/parcelInternational.png'

/* eslint-disable max-len*/
const S1 = 'I completed my Advanced Level examinations in the Physical stream at Thurstan College, Colombo 03.';
const S2 = 'I was selected for higher studies at the University of Kelaniya.';
const S3 = 'I enrolled in the Industrial Management and Information Technology program at the Faculty of Science, University of Kelaniya.';
const S4 = 'During my academic years, I worked part-time as a software developer at iTerminal Technology.';
const S5 = 'I completed a six-month internship as a software engineer at Vizuamatix Pvt Ltd.';
const S6 = 'After completing my academic studies, I started working remotely as a software engineer at Parcel International, Netherlands, for one year.';
/* eslint-enable max-len*/

export default  [
  {
    date: '05/01/2019',
    photo: ThurstanCollege,
    title: 'Thurstan Collage',
    subtitle: 'Student',
    duration: '2015 - 2018',
    content: S1
  },
  {
    date: '04/21/2020',
    photo: Univeristylogo,
    title: 'University of Kelaniya',
    subtitle: 'Undergraduate',
    duration: '2019 - 2023',
    content: S2
  },
  {
    date: '04/25/2020',
    photo: DepartmentLogo,
    title: 'Department of Industrial Management',
    subtitle: 'Undergraduate',
    duration: '2020 - 2023',
    content: S3
  },
  {
    date: '01/01/2022',
    photo: iterminalTechonologies,
    title: 'iTerminal Technology PVT (LTD)',
    subtitle: 'Software Engineer (part-time)',
    duration: '2022 - 2023',
    content: S4
  },
  {
    date: '09/01/2022',
    photo: VizuaMatix,
    title: 'ViuzaMatix PVT (LTD)',
    subtitle: 'Intern - Software Engineer',
    duration: '2022 - 2023',
    content: S5
  },
  {
    date: '07/08/2023',
    photo: ParcelInternational,
    title: 'Parcel International, Netherlands',
    subtitle: 'Software Engineer',
    duration: '2023 - 2024',
    content: S6
  },
];